/* eslint-disable import/no-named-as-default-member */
import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import _ from "lodash";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import { withStyles } from "@material-ui/core/styles";
import { Paper, Fade, Collapse, Grid } from "@material-ui/core";

// Screen Preference Imports
import ControlledLoanPrefTable from "../../../Global/TablePreferenceColumns/ControlledLoanPrefTable";
import loanStatuses from "../../../../constants/loanStatuses";
import { getLoansByPreferenceAndLoanStatus, getPipelineDealLoanCounts, downloadDealQuotes } from "../../../../store/state/loan/loan";
import { getScreenPreferences } from "../../../../shared-utility/store/state/screenPreferences";
import LenderPassedLoanTableColumns from "../../../Global/TablePreferenceColumns/LoanTableColumns/LenderPassedLoanTableColumns";
import RejectedLoanTableColumns from "../../../Global/TablePreferenceColumns/LoanTableColumns/RejectedLoanTableColumns";
import guestPermissionHelper from "../../../../utils/guestPermissionHelper";
import NoQuotes from "./NoQuotes";
import { Pointer, GridBadge } from "./styles";
import materialStyles from "../materialStyles";
import SubsectionTitle from "../components/SubsectionTitle";
import dealStatuses from "../../../../constants/status";
import TablePaginationHelper from "../../../../utils/tablePaginationHelper";

class PassedAndRejectedQuotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      tabValue: 0
    };
    this.tablePaginationHelperLenderPassed = new TablePaginationHelper("638bcaa8-87b0-4ae5-ae3b-9fceae5d3ca2", 10);
    this.tablePaginationHelperRejected = new TablePaginationHelper("7b2a664d-2e0f-4b08-9f5d-bc50207ed67b", 10);
  }

  componentDidMount() {
    this.props.getScreenPreferences({
      screenType: "lender_passed_loan_table"
    });
    this.props.getScreenPreferences({
      screenType: "rejected_loan_table"
    });
    this.getRejectedAndPassedCounts();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isExpired } = this.props;
    const { isExpired: prevIsExpired } = prevProps;
    const { isExpanded } = this.state;
    const { isExpanded: prevIsExpanded } = prevState;
    if (isExpired && !prevIsExpired) {
      this.getRejectedAndPassedCounts();
    }
    if (isExpanded && !prevIsExpanded) {
      this.getPaginatedLenderPassed(this.tablePaginationHelperLenderPassed.page, this.tablePaginationHelperLenderPassed.rowsPerPage);
      this.getPaginatedRejected(this.tablePaginationHelperRejected.page, this.tablePaginationHelperRejected.rowsPerPage);
    }
    if (this.props.refreshGrid) {
      this.props.gridRefreshedCallback();
      this.getRejectedAndPassedCounts();
      this.getPaginatedLenderPassed(this.tablePaginationHelperLenderPassed.page, this.tablePaginationHelperLenderPassed.rowsPerPage);
      this.getPaginatedRejected(this.tablePaginationHelperRejected.page, this.tablePaginationHelperRejected.rowsPerPage);
    }
  }

  getRejectedAndPassedCounts = () => {
    this.props.getPipelineDealLoanCounts({
      dealId: this.props.dealId
    });
  };

  getLenderPassedPreferenceColumns = () => {
    const { lenderPassedPrefs } = this.props;
    if (lenderPassedPrefs) {
      const prefElementIds = lenderPassedPrefs.map(x => x.screenElementId);
      return LenderPassedLoanTableColumns.filter(x => x.id && x.dataField && _.includes(prefElementIds, x.id)).map(x => x.dataField);
    }
    return undefined;
  };

  getRejectedPreferenceColumns = () => {
    const { rejectedPrefs } = this.props;
    if (rejectedPrefs) {
      const prefElementIds = rejectedPrefs.filter(x => x.isSelected).map(x => x.screenElementId);
      return RejectedLoanTableColumns.filter(x => x.id && x.dataField && _.includes(prefElementIds, x.id)).map(x => x.dataField);
    }
    return undefined;
  };

  getPaginatedLenderPassed = (page, pageSize, sortOrder) => {
    const desiredColumns = this.getLenderPassedPreferenceColumns();
    this.props.getLoansByPreferenceAndLoanStatus({
      subKey: "lender_passed_loan_table",
      loanStatusId: loanStatuses.PASSED_QUOTE,
      dealId: this.props.dealId,
      columns: desiredColumns,
      page,
      pageSize,
      sortOrder
    });
  };

  getPaginatedRejected = (page, pageSize, sortOrder) => {
    const desiredColumns = this.getRejectedPreferenceColumns();
    this.props.getLoansByPreferenceAndLoanStatus({
      subKey: "rejected_loan_table",
      loanStatusId: loanStatuses.REJECTED_QUOTE,
      dealId: this.props.dealId,
      columns: desiredColumns,
      page,
      pageSize,
      sortOrder
    });
  };

  toggleQuotes = () => {
    this.setState(previousState => ({
      isExpanded: !previousState.isExpanded
    }));
  };

  handleTabChange = (_event, value) => {
    this.setState({ tabValue: value });
    if (value === 0) this.getPaginatedLenderPassed(this.tablePaginationHelperLenderPassed.page, this.tablePaginationHelperLenderPassed.rowsPerPage);
    if (value === 1) this.getPaginatedRejected(this.tablePaginationHelperRejected.page, this.tablePaginationHelperRejected.rowsPerPage);
  };

  lenderPassedUpdateTableState = payload => {
    this.setState({
      lenderPassedTableState: {
        ...payload
      }
    });
    this.getPaginatedLenderPassed(payload.page, payload.pageSize, payload.sortOrder);
  };

  rejectedUpdateTableState = payload => {
    this.getPaginatedRejected(payload.page, payload.pageSize, payload.sortOrder);
  };

  downloadPassedLoans = () => {
    const payload = {
      loanStatusIds: [loanStatuses.PASSED_QUOTE],
      dealId: this.props.dealId,
      ...this.state.lenderPassedTableState,
      columns: this.getLenderPassedPreferenceColumns(),
      screenType: "lender_passed_loan_table"
    };
    this.props.downloadDealQuotes(payload);
  };

  downloadRejectedLoans = () => {
    const payload = {
      loanStatusIds: [loanStatuses.REJECTED_QUOTE],
      dealId: this.props.dealId,
      ...this.state.rejectedTableState,
      columns: this.getRejectedPreferenceColumns(),
      screenType: "rejected_loan_table"
    };
    this.props.downloadDealQuotes(payload);
  };

  render() {
    const { isExpanded, tabValue } = this.state;
    const {
      classes,
      isExpired,
      onExpired,
      lenderPassedLoanData,
      lenderPassedPrefs,
      rejectedLoanData,
      rejectedPrefs,
      combinedCount,
      lenderPassedCount,
      rejectedCount,
      deal
    } = this.props;

    if (!deal) {
      return null;
    }

    if (deal.dealStatusId === dealStatuses.ADDING_SUPPELEMENTAL) {
      const inClosingLoans = this.props.supplementalLoans.filter(loan => loan.loanStatusId === loanStatuses.IN_CLOSING);
      if (rejectedLoanData.data && rejectedLoanData.data.loans && rejectedCount > 0) {
        rejectedLoanData.data.loans = rejectedLoanData.data.loans.filter(
          rejectedLoan => !rejectedLoan.winningLoanId || inClosingLoans.filter(inClosingLoan => inClosingLoan.id === rejectedLoan.winningLoanId).length > 0
        );
        rejectedLoanData.data.count = rejectedLoanData.data.loans.length;
      }
      if (lenderPassedLoanData.data && lenderPassedLoanData.data.loans && lenderPassedCount > 0) {
        lenderPassedLoanData.data.loans = lenderPassedLoanData.data.loans.filter(
          passedLoan => !passedLoan.winningLoanId || inClosingLoans.filter(inClosingLoan => inClosingLoan.id === passedLoan.winningLoanId).length > 0
        );
        lenderPassedLoanData.data.count = lenderPassedLoanData.data.loans.length;
      }
    }

    const tempLenderPassedLoanTableColumns = guestPermissionHelper.getTableColumns(this.props.guestPermissions, LenderPassedLoanTableColumns);
    const tempRejectedLoanTableColumns = guestPermissionHelper.getTableColumns(this.props.guestPermissions, RejectedLoanTableColumns);

    return (
      <>
        <Grid container direction="row" spacing={16}>
          <Grid item>
            <SubsectionTitle title="Rejected/Passed" />
          </Grid>
          <Grid item>
            {!isExpanded && (
              <GridBadge badgeContent={combinedCount || 0} classes={{ badge: classes.badge }}>
                <span />
              </GridBadge>
            )}
          </Grid>
          <Grid item>
            <Pointer onClick={this.toggleQuotes}>{isExpanded ? "HIDE" : "SHOW"}</Pointer>
          </Grid>
        </Grid>
        <Collapse in={isExpanded}>
          <Paper elevation={4}>
            <Tabs value={tabValue} onChange={this.handleTabChange} classes={{ indicator: classes.tabsIndicator }}>
              <Tab
                disableRipple
                label="Rejected"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected
                }}
              />
              <Tab
                disableRipple
                label="Lender Passed"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected
                }}
              />
            </Tabs>
            {tabValue === 1 && (
              <>
                {lenderPassedCount > 0 && (
                  <Fade in={lenderPassedLoanData.data !== null}>
                    <Paper elevation={4}>
                      <ControlledLoanPrefTable
                        updateTableState={this.lenderPassedUpdateTableState}
                        isExpired={isExpired}
                        setExpired={onExpired}
                        shouldHideConfig
                        screenType="lender_passed_loan_table"
                        tableScreenElements={tempLenderPassedLoanTableColumns}
                        screenPreferences={lenderPassedPrefs}
                        dealId={this.props.dealId}
                        tableData={lenderPassedLoanData}
                        downloadLoans={this.downloadPassedLoans}
                        tableConfigItemId="638bcaa8-87b0-4ae5-ae3b-9fceae5d3ca2"
                      />
                    </Paper>
                  </Fade>
                )}
                {lenderPassedCount === 0 && (
                  <Fade in={lenderPassedCount === 0}>
                    <Paper elevation={4}>
                      <NoQuotes />
                    </Paper>
                  </Fade>
                )}
              </>
            )}
            {tabValue === 0 && (
              <>
                {rejectedCount > 0 && (
                  <Fade in={rejectedLoanData.data !== null}>
                    <Paper elevation={4}>
                      <ControlledLoanPrefTable
                        updateTableState={this.rejectedUpdateTableState}
                        isExpired={isExpired}
                        setExpired={onExpired}
                        screenType="rejected_loan_table"
                        tableScreenElements={tempRejectedLoanTableColumns}
                        screenPreferences={rejectedPrefs}
                        dealId={this.props.dealId}
                        tableData={rejectedLoanData}
                        downloadLoans={this.downloadRejectedLoans}
                        tableConfigItemId="7b2a664d-2e0f-4b08-9f5d-bc50207ed67b"
                      />
                    </Paper>
                  </Fade>
                )}
                {rejectedCount === 0 && (
                  <Fade in={rejectedCount === 0}>
                    <Paper elevation={4}>
                      <NoQuotes />
                    </Paper>
                  </Fade>
                )}
              </>
            )}
          </Paper>
        </Collapse>
      </>
    );
  }
}

const mapStateToProps = ({ authentication, loan, screenPreferences }) => ({
  authentication,
  lenderPassedPrefs: screenPreferences.screen_pref.lender_passed_loan_table,
  rejectedPrefs: screenPreferences.screen_pref.rejected_loan_table,
  lenderPassedLoanData: loan.loansByPreference.lender_passed_loan_table || {},
  rejectedLoanData: loan.loansByPreference.rejected_loan_table || {},
  lenderPassedCount: loan.loanCounts.lenderPassed,
  rejectedCount: loan.loanCounts.rejected,
  combinedCount: loan.loanCounts.lenderPassed + loan.loanCounts.rejected || 0,
  supplementalLoans: loan.loansByPreference.supplemental_loan_table ? loan.loansByPreference.supplemental_loan_table.data.loans : []
});

export default compose(
  connect(mapStateToProps, { getLoansByPreferenceAndLoanStatus, getPipelineDealLoanCounts, getScreenPreferences, downloadDealQuotes }),
  withStyles(materialStyles)
)(PassedAndRejectedQuotes);
